import { render, staticRenderFns } from "./highPressureFanLess.vue?vue&type=template&id=06727016&scoped=true&lang=pug"
import script from "./highPressureFanLess.vue?vue&type=script&lang=js"
export * from "./highPressureFanLess.vue?vue&type=script&lang=js"
import style0 from "./highPressureFanLess.vue?vue&type=style&index=0&id=06727016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06727016",
  null
  
)

export default component.exports